<template>
  <modal
    size="md"
    ref="modal"
    :show="show"
    :hide-footer="true"
    :hide-header="true"
    :scrollable="false"
    :show-close-icon="true"
    modal-class="paywall-modal"
    @hidden="$emit('input', false)"
  >
    <paywall :heading="heading" :feature-type="featureType">
      <div slot="heading" v-if="$slots.heading">
        <slot name="heading" />
      </div>
      <div slot="content">
        <slot name="content" />
      </div>
    </paywall>
  </modal>
</template>

<script>
import Modal from '@/components/Modal.vue'
import Paywall from '@/components/paywalls/Paywall.vue'

/**
 * This shows the paywall info in a modal. It accepts heading and content slot.
 */
export default {
  name: 'PaywallModal',
  props: ['show', 'heading', 'featureType'],
  model: {
    prop: 'show'
  },
  components: {
    Modal,
    Paywall
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss">
.paywall-modal {
  margin-top: 55px;
  .modal-content {
    padding: 0;
  }
}
</style>
